import { render, staticRenderFns } from "./ReportsDisclaimer.vue?vue&type=template&id=539e4a10&scoped=true&"
import script from "./ReportsDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ReportsDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDisclaimer.vue?vue&type=style&index=0&id=539e4a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e4a10",
  null
  
)

export default component.exports